import builder from '../builder';
import Subtract from '../../streamline-icons/light/subtract.svg';

export default builder('IconSubtractLight', Subtract);
